export default __webpack_public_path__ + "static/media/howtouse_basic_06_ko.6e60c25a.png";